import {
  fetchGoogleAnalyticsData,
  fetchSummaryData,
} from "./actions/fetchActions";
import {
  summaryDataReducer,
  googleAnalyticsDataReducer,
} from "./reducers/fetchReducers";

const dashReducers = {
  summaryDataGlobalStore: summaryDataReducer,
  googleAnalyticsGlobalStore: googleAnalyticsDataReducer,
};

export { fetchGoogleAnalyticsData, fetchSummaryData, dashReducers };
